const apportionment = (value, divider) => {
  const aux = Math.floor((value / divider) * 100);
  const chargeFinalValue = aux / 100;
  const rest = value - chargeFinalValue * divider;

  return {
    parcel: chargeFinalValue,
    rest: rest,
  };
};

export { apportionment };
